const reportQueryOptions = (t) => [
  {
    name: 'schoolName',
    displayName: t('chartQueryBuilder.queryOptions.report.schoolName'),
    type: 'schoolName',
    used: false,
    value: ''
  },
  {
    name: 'className',
    displayName: t('chartQueryBuilder.queryOptions.report.className'),
    type: 'className',
    used: false,
    value: ''
  },
  {
    name: 'createdAt',
    displayName: t('chartQueryBuilder.queryOptions.report.date'),
    type: 'date',
    used: false,
    value: ''
  },
  {
    name: 'pagination',
    displayName: '',
    type: 'pagination',
    used: true,
    value: ''
  }
];

export default reportQueryOptions;
